import { Avatar, Typography } from 'antd';
import coverageIcon from 'assets/images/coverage.png';
import demoRisk from 'assets/images/demo-risk.png';
import riskUserIcon from 'assets/images/risk-block-user.png';
import safetyIcon from 'assets/images/safety.png';
import React from 'react';
import * as DS from '../DealRoomSection.styles';
import * as S from './CommitteeRisk.styles';

const { Title, Paragraph } = Typography;

const CommitteeRisk: React.FC = () => {
  return (
    <S.Wrapper>
      {/* Header */}
      <S.Header>
        <Avatar className="user-icon" src={riskUserIcon} size={80} />
        <S.HeaderContent>
          <Title level={5} className="title">{`עו"ד עפר שחל`}</Title>
          <Paragraph className="sub-text">{`מחבר הספר`}</Paragraph>
          <Paragraph className="sub-text">{`"המדריך השלם לבית המשותף"`}</Paragraph>
        </S.HeaderContent>
      </S.Header>

      <DS.ContentTextWrapper className="px-0">
        <S.ParagraphContent>
          {`ניתן לתבוע אותך באופן אישי על רשלנות. "ביטוח תביעות אישיות" לחברי וחברות ועד הבית אינו מכסה תביעות מסוג זה.`}
        </S.ParagraphContent>
        <S.ParagraphContent>
          {`בשנת 2016 התקשרו אלי כמה עשרות בעלי דירות וביקשו לקבוע פגישה בהולה. הפונים גרו בדירות במגדל בגשר ההלכה. מה שסיפרו לי נשמע הזוי ולא יאמן: באחת הדירות בבניין פרצה אש שהתפשטה במהירות מחלונות הדירה ושרפה את כל הקיר החיצוני של הבניין. הנזק היה עצום. עלות שיפוץ של מיליוני שקלים!`}
        </S.ParagraphContent>
      </DS.ContentTextWrapper>

      {/* Section */}
      <S.TitleSection>
        <img src={coverageIcon} className="icon" />
        <Title level={5}>חשיבות השמירה על בטיחות</Title>
      </S.TitleSection>

      <DS.ContentTextWrapper className="px-0">
        <S.ParagraphContent>{`התשובה המצערת היתה: כן, אבל רק ביטוח חבויות, ללא ביטוח מבנה. חשוב להבין - תאונות מתרחשות, זה קורה לכולם. יש דברים שלא ניתן לחסוך בהם כי במקרי חירום אין דרך חזרה. ואכן, בבניין המדובר, גם היום, 8 שנים אחרי האירוע, עדיין מתקיימים הליכים משפטיים וסכסוכים שמונעים את שיקומו.`}</S.ParagraphContent>
        <S.ParagraphContent>{`אם הוועד היה רוכש ביטוח מבנה, ניתן היה לשקם את הרכוש המשותף ללא עלויות חריגות לכלל בעלי הדירות בבניין. ולא רק זה, ביטוח מבנה בפוליסה לבית משותף הוא מלכתחילה שולי ביותר מבחינה כספית (במרבית הבניינים כ-10% מהתקציב השנתי של מיסי הוועד).
למרבה הצער הבניין הזה הוא לא היחיד.`}</S.ParagraphContent>
        <S.ParagraphContent>{`אני נתקל במקרים בהם ועדי בתים לא מבטחים, או מבטחים חלקית בלבד, משיקולים תקציביים או מחוסר מודעות. כשמתרחש אירוע תאונתי מהותי (למשל הצפת חדר משאבות, שריפה, נזק מים למעלית) כבר מאוחר מדי לתקן את טעויות הביטוח שנעשו וצריך לשאת בעלויות כבדות.`}</S.ParagraphContent>
      </DS.ContentTextWrapper>

      {/* Section */}
      <S.TitleSection>
        <img src={safetyIcon} className="icon" />
        <Title level={5} className="title">
          נזקי שריפות והתקלות
        </Title>
      </S.TitleSection>

      <DS.ContentTextWrapper className="px-0">
        <S.ParagraphContent>{`בבניינים רבים פועל ועד בית בהתנדבות, ובחלק מהמקרים הוועד נעזר בשירותים של חברת ניהול. ועד הבית נושא באחריות, ואף באחריות אישית, להיעדר ביטוח או להיעדר כיסוי מספיק. לכן, המלצתי החד משמעית היא לעשות ביטוח מלא. היעדר ביטוח לרכוש המשותף (ביטוח מבנה) וצד ג', מהווה רשלנות ומטיל אחריות נזיקית. תביעות נזיקיות מסתכמות לרוב במאות אלפי שקלים וייצוג משפטי בתביעות כאלה מגיע לעשרות אלפי שקלים נוספים.`}</S.ParagraphContent>
        <S.ParagraphContent>{`אם הוועד היה רוכש ביטוח מבנה, ניתן היה לשקם את הרכוש המשותף ללא עלויות חריגות לכלל בעלי הדירות בבניין. ולא רק זה, ביטוח מבנה בפוליסה לבית משותף הוא מלכתחילה שולי ביותר מבחינה כספית (במרבית הבניינים כ-10% מהתקציב השנתי של מיסי הוועד). `}</S.ParagraphContent>
        <S.ParagraphContent>{`למרבה הצער הבניין הזה הוא לא היחיד.`}</S.ParagraphContent>
        <S.ParagraphContent className="mb-24">{`אני נתקל במקרים בהם ועדי בתים לא מבטחים, או מבטחים חלקית בלבד, משיקולים תקציביים או מחוסר מודעות. כשמתרחש אירוע תאונתי מהותי (למשל הצפת חדר משאבות, שריפה, נזק מים למעלית) כבר מאוחר מדי לתקן את טעויות הביטוח שנעשו וצריך לשאת בעלויות כבדות.`}</S.ParagraphContent>
        <S.ParagraphContent className="mb-20">{`חברי וחברות ועד שמוגשת נגדם תביעה כזו, לא יוכלו להתגונן בטענה שיש חברת ניהול או מתחזק שאחראים על הביטוח. קיום ביטוחים מלאים הוא באחריות ועד הבית, גם כאשר יש חברת ניהול או מתחזק. אם מישהו מחברי הוועד מטיל ספק בנחיצות העניין, חשוב להביא את הנושא לדיון בפני כלל בעלי הדירות, להציג בפניהם את הסיכונים אליהם הם עלולים להיחשף, ורק בהתאם לכך לקבל את ההחלטה ולדאוג שתירשם בפרוטוקול.`}</S.ParagraphContent>
      </DS.ContentTextWrapper>

      {/* Images */}
      <S.Image src={demoRisk} alt="fire" />

      {/* Section */}
      <S.TitleSection>
        <Title level={5} className="title mb-8">
          לסיכום,
        </Title>
      </S.TitleSection>

      <DS.ContentTextWrapper className="px-0">
        <S.ListWrapper className="normal-number">
          <S.ListItem>
            <S.ListContent>{`הצטרפת לוועד הבית? חשוב לקחת בחשבון את האפשרות של תביעת רשלנות אם הוועד לא רוכש ביטוח מספיק.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListContent>{`ביטוח אחריות מקצועית של חברת ניהול אינו מכסה תביעה כזו משום שיש החרגה בפוליסה על אי רכישת ביטוח. גם בביטוח תביעות אישיות לחברי ועד בית יש החרגה דומה.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListContent>{`לכן – לפני כל צעד שלך בוועד הבית, חשוב לדאוג לביטוח מלא שמגן עליך ועל הוועד מפני כל תביעה או לחילופין להביא את הנושא לדיון בפני כלל בעלי הדירות, להציג בפניהם את הסיכונים אליהם הם עלולים להיחשף ללא ביטוח מבנה, לקיים הצבעה מסודרת ולדאוג שתירשם בפרוטוקול.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </DS.ContentTextWrapper>
    </S.Wrapper>
  );
};

export default CommitteeRisk;
